// extracted by css-extract-rspack-plugin
export default {"UpsellCTALink":"_0jNw","UpsellBannerComponent":"JDCL9","SecondaryCTALink":"W9VW0","UpsellBigCardComponent":"dNMBP"};